import React, {  Component } from 'react';

export default class SelectPriceSourceOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			selectedPriceSource: "",
            errorMessage: '',
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }
	handleChange(event) {
		this.setState({
            selectedPriceSource: event.target.value,
            errorMessage: '',
        });
	}
	handleContinue(event) {
		event.preventDefault();
        if(this.state.selectedPriceSource) {
            this.props.changeSelectedPriceSource(parseInt(this.state.selectedPriceSource, 10));
    		this.setState({
                showDialog: false,
                errorMessage: '',
            });
        } else {
            this.setState({
                errorMessage: 'Please select sales agreement'
            });
        }
	}
    componentDidMount() {
		// window.scrollTo(0, 0);
        let flag = false;
        const self = this;
        const { selectedAccountsAllPriceSources } = self.props;
        if(selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === event.target.value.toString())) {
            flag = true;
        }
        self.setState({
            showDialog: self.props.showDialog,
			selectedPriceSource: flag ? self.props.selectedPriceSource : ''
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="showPriceSourceOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">SELECT SALES AGREEMENT</h2>
					<p className="bold">Please select which sales agreement you want to use to order this product.</p>
                    {this.state.errorMessage && <p className="red bold">{this.state.errorMessage}</p>}
					<select defaultValue={this.props.selectedPriceSource} onChange={this.handleChange.bind(this)} style={{width: '100%'}}>
                        <option value="">-- Select Sales Agreement --</option>
						{this.props.selectedAccountsAllPriceSources.responseObject.filter((itm)=>{
										return itm.PRICE_LIST_NAME != "APPLIANCES - BLEM LOAD PRICE LIST" && itm.AGREEMENT_TYPE !== 'GEA Parts' && itm.AGREEMENT_TYPE != "GEA FS Standard Agreement"
									}).map((item, index) => {
							return <option value={item.AGREEMENT_NUMBER} key={index}>{item.DISPLAY_AGREEMENT_NAME}</option>
						})}
					</select>
					<div className="noButtonContainer">
						<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
					</div>
					<div className="yesButtonContainer">
						<a className="yesButton blueButton" onClick={this.handleContinue.bind(this)}>Continue</a>
					</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectPriceSourceOverlayDialog.js